import React from "react";
import { Button, Img, Input, Spinner, Text } from "components";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { useAppSelector, useAppDispatch } from "redux/hooks";
import {
  setReferenceNumber,
  setAmount,
  setSupportingDocument,
} from "../../redux/features/AddDeclaration/index";
import {
  PostDiscloseRequestType,
  postDisclose,
} from "service/apis/CreateOrderapi";
import { AxiosRequestConfig } from "axios";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";


const AddDeclaration: React.FC<any> = ({ setShowAddDeclaration }) => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = React.useState(false);
  const [supporting_documentfile, setSupportingDocumentfile] =
    React.useState<File>();
  const { reference_number, amount, supporting_document } = useAppSelector(
    (state) => state.AddDeclaration
  );
  const customers_id = useAppSelector(
    (state) => state.CreateOrder.customers_id
  );

  React.useEffect(() => {
    if (supporting_documentfile instanceof File) {
      const reader = new FileReader();
      reader.onload = (event) => {
        if (event.target?.result) {
          dispatch(setSupportingDocument(event.target.result.toString()));
        }
      };
      reader.readAsDataURL(supporting_documentfile);
    }
  }, [supporting_documentfile]);

  const handleonAddDeclaration = (): void | null => {
    // get auth token from localstorage
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return null;
    const authToken = JSON.parse(auth);

    const payload: AxiosRequestConfig<PostDiscloseRequestType> = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      data: {
        customers_id: customers_id,
        purpose: reference_number,
        amount: amount,
        supporting_document: supporting_document,
        date: new Date().toISOString().slice(0, 10),
      },
    };
    setLoading(true);
    postDisclose(payload)
      .then((res) => {
        dispatch(setReferenceNumber(""));
        dispatch(setAmount(""));
        dispatch(setSupportingDocument(""));
        setLoading(false);
        setShowAddDeclaration(false);
      })
      .catch((err) => {
        setLoading(false);
        toast.error("Something went wrong");
      });
  };

  return (
    <>
       {loading && (<Spinner/>)}
      <div className="rounded-[10px] relative flex flex-col items-center justify-between bg-[#FFFFFF] h-[493px] sm:h-[493px] sm:w-[300px] w-[450px] py-[50px] px-[20px] sm:px-[10px] sm:py-[40px]">
        <div
          className="absolute top-[10px] right-[10px]"
          //   onClick={() => setShowOtp(false)}
        >
          <AiOutlineCloseCircle
            onClick={() => setShowAddDeclaration(false)}
            className="text-[30px] cursor-pointer"
          />
        </div>
        <Text
          className="text-black font-[800] text-[16px] leading-[25px]"
          // size="txtRubikRomanRegular20"
        >
          Add Declaration
        </Text>
        <div className="flex flex-col gap-2.5 items-start justify-start w-full">
          <Text className="font-bold text-[15px] text-black-900_dd tracking-[0.15px] w-auto">
            Reference Number
          </Text>
          <Input
            name="input_One"
            value={reference_number}
            onChange={(e) => dispatch(setReferenceNumber(e))}
            placeholder="Enter Reference Number"
            className="p-0 placeholder:text-black-900_99 sm:pr-5 text-[15px]text-left w-full"
            wrapClassName="bg-white-A700 border border-black-900_4c border-solid pl-[11px] pr-[35px] py-4 rounded-lg w-full"
          ></Input>
          <Text className="font-bold text-[15px] text-black-900_dd tracking-[0.15px] w-auto">
            Amount
          </Text>
          <Input
            name="input_One"
            value={amount}
            onChange={(e) => dispatch(setAmount(e))}
            placeholder="Enter Amount"
            className="p-0 placeholder:text-black-900_99 sm:pr-5 text-[15px]text-left w-full"
            wrapClassName="bg-white-A700 border border-black-900_4c border-solid pl-[11px] pr-[35px] py-4 rounded-lg w-full"
          ></Input>
          <Text className="font-bold text-[15px] text-black-900_dd tracking-[0.15px] w-auto">
            Supporting Document
          </Text>
          <Input
            name="upload"
            type="file"
            // value={}
            onChange={(e) => setSupportingDocumentfile(e)}
            placeholder="Upload Latest Copy of Electricity Bill"
            className="md:h-auto p-0 placeholder:text-black-900_7f_01 sm:h-auto sm:pr-5 text-[15px] text-black-900_7f_01 text-left tracking-[0.50px] w-full"
            wrapClassName="border border-black-900_4c border-solid flex pl-[13px] pr-[35px] py-[15px] rounded-lg w-full"
            accept="*"
            prefix={
              <Img
                className="h-6 mr-[17px] my-auto"
                src="images/img_upload_blue_gray_300.svg"
                alt="upload"
              />
            }
          ></Input>
        </div>
        <Button
          onClick={() => {
            handleonAddDeclaration();
          }}
          className="bg-blue-700 cursor-pointer font-inter w-full mx-10 py-2.5 rounded-md shadow-bs2 text-base text-center text-white-A700"
        >
          Add Declaration
        </Button>
      </div>
      <ToastContainer />
    </>
  );
};

export default AddDeclaration;
